import { createContext } from 'react';
export const NavigationComponentsContext = /*#__PURE__*/createContext(undefined);